import styled from "styled-components";

export const StyledBody = styled.div`
  height: 100%;
  background: #f5f5f5;

  `;
